import styled, { css } from 'styled-components';

interface Props {
  noWrap?: boolean;
}

export const DataTable = styled('table')<Props>`
  width: 100%;
  table-layout: auto;
  margin: 0 auto;
  border-spacing: 0;
  color: ${({ theme }) => theme.color.white};
  background-color: ${({ theme }) => theme.color.black};
  user-select: none;
  th,
  td {
    padding: 0;
    white-space: nowrap;
  }
  thead tr th {
    ${({ theme }) => theme.typography.tiny}
    border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.2)};
    text-align: left;
    text-transform: capitalize;
    ${({ noWrap }) => (noWrap ? 'white-space: nowrap;' : '')};
  }
  tbody tr td {
    ${({ theme }) => theme.typography.tiny};
    border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.2)};
    text-align: left;
    vertical-align: top;
    ${({ noWrap }) => (noWrap ? 'white-space: nowrap;' : '')};
    &:first-child {
      color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
    }
    &:nth-child(2) {
      width: 100%;
      padding-left: ${({ theme }) => theme.x2spacePx}px;
    }
  }
`;

export const Title = styled('td')`
  text-transform: capitalize;
`;

interface ValueProps {
  colorNeg?: string;
  colorPos?: string;
  noData?: boolean;
  postfix?: string;
  prefix?: string;
  value?: number;
}

export const Value = styled('td')<ValueProps>`
  ${({ theme, noData }) => theme.typography[noData ? 'tiny' : 'tinyStrong']}

  color: ${({ colorNeg, colorPos, value, theme }) => {
    if (value !== undefined && value < 0) return colorNeg;
    if (value !== undefined && value >= 0) return colorPos;
    return theme.color.whiteRGBA(0.5);
  }};

  ${({ postfix, noData }) =>
    postfix &&
    !noData &&
    css`
      &:after {
        content: '${postfix}';
        color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
      }
    `}
  ${({ prefix, noData }) =>
    prefix &&
    !noData &&
    css`
      &:before {
        content: '${prefix}';
        color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
      }
    `}
  ${({ noData }) =>
    noData &&
    css`
      &:before {
        content: 'No data';
        color: ${({ theme }) => theme.color.whiteRGBA(0.3)};
      }
    `}
`;
